import React from 'react';

import FileUpload from '../editor/FileUpload'
import Search from '../editor/Search'
import Link from '../editor/Link'

const SliderEditor = props => {
    return (
        <div>
            {props.children}
            <Search />
            <hr />
            <Link value={props.settings.link} />
            <div className="form-group">
                <label className="col-sm-3 control-label">Etykieta</label>
                <div className="col-sm-9">
                    <input type="text" name="label" className="form-control" defaultValue={props.settings.label} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Tytuł</label>
                <div className="col-sm-9">
                    <input type="text" name="title_normal" className="form-control" defaultValue={props.settings.title_normal} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Partner</label>
                <div className="col-sm-9">
                    <input type="text" name="partner" className="form-control" defaultValue={props.settings.partner} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">Kategoria</label>
                <div className="col-sm-9">
                    <input type="text" name="category" className="form-control" defaultValue={props.settings.category} placeholder="" />
                </div>
            </div>
            <div className="form-group">
                <label className="col-sm-3 control-label">opcje</label>
                <div className="checkbox">
                    <label className="control-label">
                        <input type="hidden" name="locked" value="0" />
                        <input type="checkbox" name="locked" value="1" defaultChecked={props.settings.locked == "1"} />
						zablokuj box
						</label>
                </div>
            </div>
            <FileUpload value={props.settings['background_image1']} name="background_image1" />
            <FileUpload value={props.settings['background_image2']} name="background_image2" />
            <div className="form-group">
                <label className="col-sm-3 control-label">Tło</label>
                <div className="col-sm-9">
                    <select name="background" className="form-control" defaultValue={props.settings.background}>
                        <option value="">brak</option>
                        <option value="red">czerwone</option>
                        <option value="black">czarne</option>
                    </select>
                </div>
            </div>
        </div>
    );
}


export default SliderEditor;